var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OffersGroups',{attrs:{"bid_groups":_vm.groups,"bids":_vm.modified_items,"critery-card":_vm.criteryCard,"tender":_vm.tender,"without_select":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }